import React from "react";
import {
    TextField,
    InputAdornment,
    IconButton,
} from "@mui/material";
import { Search, Clear } from "@mui/icons-material";

const SearchInput = ({
    value,
    onChange,
    placeholder = "Search...",
    widthMobile = "180px",
    widthDesktop = "233px",
}) => {
    return (
        <TextField
            placeholder={placeholder}
            variant="outlined"
            size="small"
            value={value}
            onChange={onChange}
            sx={{
                width: {
                    xs: widthMobile,
                    sm: widthDesktop,
                },
                "& .MuiOutlinedInput-root": {
                    borderRadius: 1,
                    paddingTop: 0.5,
                    paddingBottom: 0.5,
                    paddingRight: 0,
                    border: (theme) => `1px solid ${theme.palette.neutral.deep}`,
                },
                "& .MuiOutlinedInput-input": {
                    padding: "4px 4px",
                },
            }}
            slotProps={{
                input: {
                    startAdornment: (
                        <Search
                            fontSize="small"
                            sx={{ color: "text.secondary" }}
                        />
                    ),
                    endAdornment: value ? (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="clear search"
                                size="small"
                                onClick={() =>
                                    onChange({ target: { value: "" } })
                                }
                            >
                                <Clear fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ) : null,
                },
            }}
        />
    );
};

export default SearchInput;